import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, CalendarCheck, ClipboardList } from 'lucide-react';

export const userNav = (isHovered, styles) => (
     <>
          <NavLink to="/dashboard" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
               <Home size={20} />
               {isHovered && <span>Dashboard</span>}
          </NavLink>
          <NavLink to="/attendance" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
               <CalendarCheck size={20} />
               {isHovered && <span>Attendance</span>}
          </NavLink>
          <NavLink to="/new-radiology-assessment" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
               <ClipboardList size={20} />
               {isHovered && <span>Radiology Assessment</span>}
          </NavLink>
     </>
);